export const durationsDe = [
  {
    text: "kürzer als 6 Tage",
    value: "14762",
  },
  {
    text: "6 - 9 Tage",
    value: "14763",
  },
  {
    text: "10 - 15 Tage",
    value: "14764",
  },
  {
    text: "länger als 15 Tage",
    value: "14765",
  },
];
